import { render } from "./AutoGiro.vue?vue&type=template&id=5950aed6&scoped=true"
import script from "./AutoGiro.vue?vue&type=script&lang=js"
export * from "./AutoGiro.vue?vue&type=script&lang=js"

import "./AutoGiro.vue?vue&type=style&index=0&id=5950aed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5950aed6"]])

export default __exports__